import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import moduleProducts from './module/moduleProducts'
import moduleAuth from './module/moduleAuth'
import moduleAccount from './module/moduleAccount'
import moduleReports from './module/moduleReports'
import moduleSalesReports from './module/moduleSalesReports'
import moduleDashboard from './module/moduleDashboard'
import moduleTrend from './module/moduleTrend'
import moduleAnalytics from './module/moduleAnalytics'
import moduleCampaignReport from './module/moduleCampaignReport'
import moduleResource from './module/moduleResource'
import moduleMonitoring from './module/moduleMonitoring'
import moduleKeywordReports from './module/moduleKeywordReports'
import moduleReviewRequest from './module/moduleReviewRequest'
import moduleNews from './module/moduleNews'
import moduleUserAccounts from './module/moduleUserAccounts'
import moduleUser from './module/moduleUser'
import moduleUserInvite from './module/moduleUserInvite'
import moduleSlideReport from './module/moduleSlideReport'
import moduleMeasure from './module/moduleMeasure'
import moduleAnalysis from './module/moduleAnalysis'
import moduleAdBid from './module/moduleAdBid'
import moduleAmcRepeat from './module/moduleAmcRepeat'
import moduleAmcArpu from './module/moduleAmcArpu'
import moduleAmcRfm from './module/moduleAmcRfm'
import moduleAmcAdCampaign from './module/moduleAmcAdCampaign'
import moduleAmcAdKeyword from './module/moduleAmcAdKeyword'
import moduleAmcSegment from './module/moduleAmcSegment'
import moduleAmcAffinityReports from './module/moduleAmcAffinityReports'
import moduleAmcSetting from './module/moduleAmcSetting'
import moduleAmcAudience from './module/moduleAmcAudience'
import moduleAmcProfile from './module/moduleAmcProfile'
import moduleAmcBrandReports from './module/moduleAmcBrandReports'
import moduleAmcEcUserAnalysis from './module/moduleAmcEcUserAnalysis'

export default createStore({
  modules: {
    auth: moduleAuth,
    account: moduleAccount,
    product: moduleProducts,
    report: moduleReports,
    salesReport: moduleSalesReports,
    dashboard: moduleDashboard,
    trend: moduleTrend,
    analytics: moduleAnalytics,
    resource: moduleResource,
    monitoring: moduleMonitoring,
    keywordReport: moduleKeywordReports,
    reviewRequest: moduleReviewRequest,
    news: moduleNews,
    userAccounts: moduleUserAccounts,
    user: moduleUser,
    userInvite: moduleUserInvite,
    slideReport: moduleSlideReport,
    campaignReport: moduleCampaignReport,
    measure: moduleMeasure,
    analysis: moduleAnalysis,
    adBid: moduleAdBid,
    amcRepeat: moduleAmcRepeat,
    amcArpu: moduleAmcArpu,
    amcRfm: moduleAmcRfm,
    amcAdCampaign: moduleAmcAdCampaign,
    amcAdKeyword: moduleAmcAdKeyword,
    amcSegment: moduleAmcSegment,
    amcAffinityReports: moduleAmcAffinityReports,
    amcSetting: moduleAmcSetting,
    amcAudience: moduleAmcAudience,
    amcProfile: moduleAmcProfile,
    amcBrandReports: moduleAmcBrandReports,
    amcEcUserAnalysis: moduleAmcEcUserAnalysis
  },
  plugins: [
    createPersistedState({
      key: 'ubunconsole',
      paths: [
        'auth.activeUser',
        'auth.activeUserId',
        'auth.token',
        'account.activeAccount',
        'account.accounts',
        'amcProfile.activeAmcProfile',
        'amcProfile.amcProfiles'
      ],
      storage: window.sessionStorage
    })
  ],
  state: {
    ...state,
    globalError: {},
    requestingStatus: false
  },
  getters,
  mutations: {
    ...mutations,
    SET_GLOBAL_ERROR(state, { type, message }) {
      state.globalError = {
        type,
        message
      }
    },
    RESET_GLOBAL_ERROR(state) {
      state.globalError = {}
    },
    SET_REQUESTING_STATUS(state, value) {
      state.requestingStatus = {
        ...state.requestingStatus,
        ...value
      }
    },
    RESET_REQUESTING_STATUS(state) {
      state.requestingStatus = {}
    }
  },
  actions,
  strict: process.env.NODE_ENV !== 'production'
})
